import React from "react";
import ComparisonReport from "../comparison/ComparisonReport";
import BubbleChart from "../dashboard/bubbleChart";
import { useTranslation } from 'react-i18next';

const BatchComparison = () => {
  const { t } = useTranslation(['common', 'analytics']);
  return (
  <ComparisonReport
    title={t('analytics:compare.pefReport')}
    renderChart={(data, { mode, isLoading }) => (
      <BubbleChart
        data={data}
        title={t('analytics:compare.pefTitle')}
        id={Math.random()}
        loading={isLoading}
        mode={mode}
      />
    )}
  />
  );
};

export default BatchComparison;
